export const imageExtensions = ['svg', 'png', 'PNG', 'jpg', 'JPG', 'jpeg'];
